import { Auth, API } from 'aws-amplify'
var revisionChecked = 0;
export default class ApiClient {
  constructor(name) {
    this.name = name
  }

  async checkAppVersion() {
    const json = await fetch('/revision.json?' + (new Date()).getTime()).then(res => res.json())

    if (json.appVersion !== window.wcAppVersion && !revisionChecked) {
      revisionChecked = 1;
      alert('新しいバージョンのアプリケーションをご利用いただけます。\nOKを押して画面を再読込みしてください。\nうまくいかない場合は、5分ほど待ってから再度お試しください。')
      // ServiceWorkerのキャッシュを消去
      caches.keys().then(function(names) {
        for (let name of names)
          caches.delete(name)
      })
      // スーパーリロードする
      window.location.reload(true)
    }
  }

  async get(path, query, headers = {}) {
    this.checkAppVersion()

    return API.get(this.name, path, {
      headers: await this._appendAuthHeader(headers),
      queryStringParameters: this.transformQuery(query)
    })
  }

  transformQuery(query) {
    if (typeof query === 'undefined') {
      return query
    }

    // 値のないキーは抜いてクエリパラメータとして渡す
    const params = {}
    Object.keys(query).forEach(key => {
      if (query[key] === 0 || query[key] === '') {
        return false
      }
      if (Array.isArray(query[key]) && query[key].length === 0) {
        return false
      }
      params[key] = query[key]
    })
    return params
  }

  async post(path, data, headers = {}) {
    this.checkAppVersion()

    return API.post(this.name, path, {
      headers: await this._appendAuthHeader(headers),
      body: data
    })
  }

  async put(path, data, headers = {}) {
    this.checkAppVersion()

    return API.put(this.name, path, {
      headers: await this._appendAuthHeader(headers),
      body: data
    })
  }

  async delete(path, data, headers = {}) {
    this.checkAppVersion()

    return API.del(this.name, path, {
      headers: await this._appendAuthHeader(headers),
      body: data
    })
  }

  async _appendAuthHeader(headers) {
    return Object.assign({}, headers, await this._authHeader())
  }

  async _authHeader() {
    try {
      const user = await Auth.currentAuthenticatedUser()
      const token = user ? user.signInUserSession.idToken.jwtToken : ''
      return { Authorization: token }
    } catch(err) {
      // 未認証
      return {}
    }
  }
}
